import {
  AppraiserFilter,
  DeclineReasonOption,
} from '../components/appraiser-select-dialog/appraiser-select-dialog.component';

/** Decline reason options shown when switching appraiser buckets (GRP/DTD → Virtual → Staff → IA). */
export const DECLINE_OPTIONS_BY_BUCKET: Record<AppraiserFilter, DeclineReasonOption[]> = {
  'GRP/DTD': [
    { label: 'Customer Has Own Shop', value: 'CUSTOMER_HAS_OWN_SHOP' },
    { label: 'Customer Wants Physical Inspection', value: 'CUSTOMER_WANTS_PHYSICAL_INSPECTION' },
    { label: 'Other', value: 'OTHER' },
  ],
  Virtual: [
    { label: 'Customer Wants Physical Inspection', value: 'PREFERRED_APPRAISER_PHYSICAL' },
    { label: 'Customer citing technical issues', value: 'TECHNICAL_ISSUES' },
    { label: 'Not suited for Virtual inspection', value: 'NOT_SUITED_VIRTUAL' },
    { label: 'Other', value: 'OTHER' },
  ],
  Staff: [{ label: 'Other', value: 'OTHER' }],
  IA: [],
  PTL: [],
};
